import React from 'react';
import OrganizationsInput from 'components/inputs/OrganizationsInput';
import TextInput from 'components/inputs/TextInput';
import Button from 'components/common/Button';
import Form from 'components/common/Form';
import FormItem from 'components/common/FormItem';

class InviteForm extends React.PureComponent {
  state = {
    firstName: null,
    lastName: null,
    organizationId: null,
  };

  onChange = newValue => {
    this.setState(newValue);
  };

  onSubmit = () => {
    this.props.handleSubmit(this.state);
  };

  render() {
    return (
      <Form>
        <FormItem label="First">
          <TextInput value={this.state.firstName} onChange={firstName => this.onChange({ firstName })} />
        </FormItem>
        <FormItem label="Last">
          <TextInput value={this.state.lastName} onChange={lastName => this.onChange({ lastName })} />
        </FormItem>
        <FormItem label="Email">
          <TextInput value={this.state.email} onChange={email => this.onChange({ email })} />
        </FormItem>
        <FormItem label="Mobile Number">
          <TextInput value={this.state.number} onChange={number => this.onChange({ number })} />
        </FormItem>
        <FormItem label="Role">
          <TextInput value={this.state.role} onChange={role => this.onChange({ role })} />
        </FormItem>
        <FormItem label="Location">
          <TextInput value={this.state.location} onChange={location => this.onChange({ location })} />
        </FormItem>
        <FormItem label="Direct Line">
          <TextInput value={this.state.directLine} onChange={directLine => this.onChange({ directLine })} />
        </FormItem>
        <FormItem label="Organizations">
          <OrganizationsInput
            value={this.state.organizationId}
            onChange={organizationId => this.onChange({ organizationId })}
          />
        </FormItem>
        <FormItem>
          <Button fullWidth onClick={this.onSubmit}>
            Invite User
          </Button>
        </FormItem>
      </Form>
    );
  }
}

export default InviteForm;



// WEBPACK FOOTER //
// ./src/components/forms/InviteForm/index.js